import { render, staticRenderFns } from "./pagination-web.vue?vue&type=template&id=4379d140&scoped=true&"
import script from "./pagination-web.vue?vue&type=script&lang=js&"
export * from "./pagination-web.vue?vue&type=script&lang=js&"
import style0 from "./pagination-web.vue?vue&type=style&index=0&id=4379d140&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4379d140",
  null
  
)

export default component.exports